import type { Option } from '@ksyos/design-system';
import type { SingleValue } from 'react-select';
import { AsyncSelect, FormGroup } from '@ksyos/design-system';
import { useState } from 'react';
import type { OptionWithinGroup } from '@frontend/utils';
import { getServicesGroupedByEpisodeCategoriesOptions, useAbortableFetch } from '@frontend/utils';

interface IPaymentsServiceFilterProps {
    onChangeService: (episodeCategoryId: string | undefined, serviceId: string | undefined) => void;
    serviceOrEpisodeCategoryId?: string;
}

export function PaymentsServiceFilter(props: IPaymentsServiceFilterProps) {
    const abortableFetch = useAbortableFetch();

    const [serviceFilterValues, setServiceFilterValues] = useState<Option[]>([]);

    return (
        <FormGroup label="Dienst">
            <AsyncSelect
                cacheOptions={true}
                defaultOptions={true}
                isClearable={true}
                loadOptions={async (input: string) => await loadServiceFilters(input)}
                onChange={(selectedOption: SingleValue<OptionWithinGroup>) => {
                    if (selectedOption?.value) {
                        if (selectedOption.isGroupOption) {
                            props.onChangeService(undefined, selectedOption.value);
                        } else if (selectedOption.isGroupHeader) {
                            props.onChangeService(selectedOption?.value, undefined);
                        }
                    } else {
                        props.onChangeService(undefined, undefined);
                    }
                }}
                value={serviceFilterValues.find((item) => props.serviceOrEpisodeCategoryId?.includes(item.value))}
            />
        </FormGroup>
    );

    async function loadServiceFilters(input?: string) {
        let url = '/api/payments/serviceFilters';
        if (input) {
            url += `?searchText=${input}`;
        }
        const result = await abortableFetch.fetchJson(url, 'GET');
        const options = getServicesGroupedByEpisodeCategoriesOptions(result.json.items);

        setServiceFilterValues(options);

        return options;
    }
}
